<template>
  <div id="empty-layout" class="empty-layout">
    <slot />
  </div>
</template>

<script>
export default {
  name: "EmptyLayout"
}
</script>

<style lang="scss">
.empty-layout {
  height: 100%;
}
/* Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  width: 12px;
  background-color: transparent;
}
*::-webkit-scrollbar-track {
  background-color: transparent;
}
*::-webkit-scrollbar-track {
  -webkit-box-shadow: none;
}
*::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 20px;
  border: 3px solid #fff;
  -webkit-box-shadow: none;
}
*::-webkit-scrollbar-thumb:window-inactive {
  background: none;
}
body {
  font-family: "Open Sans", sans-serif;
  overflow: overlay; /*for webkit only*/
}
button {
  cursor: pointer;
}
h1 {
  font-size: 18px;
  line-height: 24px;
  font-weight: 700;
}
h1.category-name {
  color: #333333;
}
.link-common {
  color: #2E6DCB;

  &:hover {
    color: #0E57C4;
  }
  &:active {
    color: #0047B0;
  }
}

.empty-layout {
  height: 100%;
}

@media screen and (max-width: 768px) {
  .empty-layout {
    height: auto;

  }
}

</style>